var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5H19C19.5523 5.5 20 5.94772 20 6.5V8.5H12V6.5C12 5.94772 12.4477 5.5 13 5.5ZM10 6.5V8.5H7.5C5.01472 8.5 3 10.5147 3 13V24C3 26.4853 5.01472 28.5 7.5 28.5H24.5C26.9853 28.5 29 26.4853 29 24V13C29 10.5147 26.9853 8.5 24.5 8.5H22V6.5C22 4.84315 20.6569 3.5 19 3.5H13C11.3431 3.5 10 4.84315 10 6.5ZM27 14.5C27 16.1569 25.6569 17.5 24 17.5H19V17C19 16.1716 18.3284 15.5 17.5 15.5H14.5C13.6716 15.5 13 16.1716 13 17V17.5H8C6.34315 17.5 5 16.1569 5 14.5V13C5 11.6193 6.11929 10.5 7.5 10.5H24.5C25.8807 10.5 27 11.6193 27 13V14.5ZM13 19.5V20C13 20.8284 13.6716 21.5 14.5 21.5H17.5C18.3284 21.5 19 20.8284 19 20V19.5H24C25.1256 19.5 26.1643 19.1281 27 18.5004V24C27 25.3807 25.8807 26.5 24.5 26.5H7.5C6.11929 26.5 5 25.3807 5 24V18.5004C5.83566 19.1281 6.87439 19.5 8 19.5H13Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.1ce250ac4e1d7b1a197e569699760381.svg";
export { ForwardRef as ReactComponent };